export default "__VITE_ASSET__CcByw8lt__"